import { Box } from '@mantine/core';
import type { CSSProperties } from 'react';

interface PetalProps {
  readonly color?: string;
  readonly size?: number;
  readonly style?: CSSProperties;
}

// Декоративный фирменный «лепесток» (органичная клякса). Чисто декор — aria-hidden, не кликается.
export default function Petal({ color = 'var(--mantine-color-lime-3)', size = 200, style }: PetalProps) {
  return (
    <Box
      aria-hidden
      style={{
        position: 'absolute',
        width: size,
        height: size,
        background: color,
        borderRadius: '42% 58% 63% 37% / 41% 44% 56% 59%',
        pointerEvents: 'none',
        ...style,
      }}
    />
  );
}
